/**
 * Mentions Intelligence Dashboard
 *
 * High-signal intelligence page tracking:
 * - Congressional investigations
 * - Federal funding exposure to PRC-linked entities
 * - University research security failures
 * - Defense contractor and supply chain risks
 * - Strategic influence operations
 * - Data Abyss flagship reports
 */
import { LatestMentionsTemplate } from '../../components/templates/LatestMentions';

export default function LatestMentionsPage() {
  return <LatestMentionsTemplate />;
}
